import React, { useState, useMemo, useEffect } from "react";
import { Button, Input, InputDropdown } from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthLayout from "../AuthLayout";
import PhoneInputComponent from "../PhoneInputComponent";
import LoadingDots from "../LoadingDots";
// import countryList from "react-select-country-list";
// import { State } from "country-state-city";
import countries from "./country.json";
import usaStates from './usaState.json';

const RegisterForm = ({
  onSubmitSignUpHandler,
  loading,
  investorTypeData,
  handleChangeCompanyName,
  isCompanyNameExist,
  isEmailExist,
  isCompanyCooperativeEmail,
  handleCooperativeEmailAddress,
  handleChangeEmailAddress,
  title,
  stratagies,
  fundTypeData,
}) => {
  const [companyState, setCompanyState] = useState({
    value: "",
    loading: false,
    alreadyExists: false,
  });
  const [emailState, setEmailState] = useState({
    value: "",
    loading: false,
    isCooperative: false,
    alreadyExists: false,
  });
  // const [workEmailValue, setWorkEmailValue] = useState({
  //   value: "",
  //   loading: false,
  //   alreadyExists: false,
  // });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [officePhoneNumber, setOfficePhoneNumber] = useState("");
  const phoneRegExp = /^\+[0-9]{10,16}/;
  const passwordRegExp =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  // useEffect(() => {
  //   if (isEmailExist) {
  //     setEmailExist(isEmailExist);
  //   }
  // }, [isEmailExist]);
  var curr = new Date();
  curr.setDate(curr.getDate());
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState("");
  // const countriesDropDown = useMemo(() => countryList().getData(), []);
  const formik = useFormik({
    initialValues: {
      name: "",
      emailAddress: "",
      workEmail: "",
      surname: "",
      companyName: "",
      officePhoneNumber: officePhoneNumber,
      phoneNumber: phoneNumber,
      password: "",
      confirmPassword: "",
      title: "",
      city: "",
      country: "",
      zip: "",
      state: "",
      date: "",
      ...(`${title}` === "Allocator"
        ? { investorTypeId: "" }
        : { strategyId: "" }),
      ...(`${title}` === "Fund" ? { fundTypeId: "" } : ""),
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter your name"),
      surname: Yup.string().required("Please enter your surname"),
      companyName: Yup.string().required("Please enter your company name"),
      // .test("uniqueCompany", "Company already exists", function () {
      //   const { companyName = "" } = this.parent;
      //   if (companyName !== companyState.value) {
      //     if (companyName) {
      //       setCompanyState({
      //         value: companyName,
      //         loading: true,
      //         alreadyExists: false,
      //       });
      //       return new Promise((resolve, reject) => {
      //         const onSuccessCompanyCall = (result) => {
      //           setCompanyState({
      //             value: companyName,
      //             loading: false,
      //             alreadyExists: result,
      //           });
      //           resolve(!result);
      //         };

      //         handleChangeCompanyName(companyName, onSuccessCompanyCall);
      //       });
      //     }
      //   }

      //   return !companyState.alreadyExists;
      // }),
      // workEmail: Yup.string()
      //   .email("Correct your email formate")
      //   .required("Please enter a valid email!"),
      emailAddress: Yup.string()
        .email("Correct your email formate")
        .required("Please enter a valid email!")

        // .test("match", "Email do not match", function () {
        //     const { workEmail = "", emailAddress = "" } = this.parent;
        //     const workDomain = workEmail.split("@");
        //     const emailDomain = emailAddress.split("@");
        //     if (workDomain.length > 0 && emailDomain.length > 0) {
        //       return workDomain[1] === emailDomain[1];
        //     }
        //     return false;
        // })
        .test("uniqueEmail", "Email already exists", function () {
          const { emailAddress = "" } = this.parent;
          if (emailAddress !== emailState.value) {
            if (emailAddress) {
              setEmailState({
                value: emailAddress,
                loading: true,
                alreadyExists: false,
              });
              return new Promise((resolve, reject) => {
                const onSuccessEmailcall = (result) => {
                  setEmailState({
                    value: emailAddress,
                    loading: false,
                    alreadyExists: result,
                  });
                  resolve(!result);
                };
                handleChangeEmailAddress(emailAddress, onSuccessEmailcall);
              });
            }
          }
          return !emailState.alreadyExists;
        })
        .test(
          "CooperativeEmail",
          "Please Use Cooperative Email Address",
          function () {
            const { emailAddress = "" } = this.parent;
            if (emailAddress !== emailState.value) {
              if (emailAddress) {
                setEmailState({
                  value: emailAddress,
                  loading: true,
                  isCooperative: false,
                });
                return new Promise((resolve, reject) => {
                  const onSuccessEmailcall = (result) => {
                    setEmailState({
                      value: emailAddress,
                      loading: false,
                      isCooperative: result,
                    });
                    resolve(!result);
                  };
                  handleCooperativeEmailAddress(
                    emailAddress,
                    onSuccessEmailcall
                  );
                });
              }
            }

            return !emailState.isCooperative;
          }
        ),
      city: Yup.string().required("Please enter your City"),
      country: Yup.string().required("Please select your Country"),
      zip: Yup.string().required("Please enter Zip address"),
      state: Yup.string().required("Please enter your State"),

      officePhoneNumber: Yup.string().matches(
        phoneRegExp,
        "Phone number is not valid"
      ),

      title: Yup.string().required("Enter your title"),
      phoneNumber: Yup.string().matches(
        phoneRegExp,
        "Phone number is not valid"
      ),
      password: Yup.string()
        .matches(
          passwordRegExp,
          "Minimum 8 characters, at least 1 uppercase, 1 lowercase, 1 number and 1 special character required"
        )
        .required("Enter password"),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Password must match"
      ),
      ...(`${title}` === "Allocator"
        ? {
            investorTypeId: Yup.string().required(
              "Please select your investor type"
            ),
          }
        : {
            // strategyId: Yup.string().when(["title"], {
            //   is: (title) =>
            //     title == "Fund" &&
            //     fundTypeData.find((item) => item.id == formik.values.fundTypeId)
            //       ?.name === "hedgeFund",
            //   then: Yup.string().required(
            //     "Strategy ID is required for hedge funds"
            //   ),
            // }),
          }),
      ...(`${title}` === "Fund"
        ? { fundTypeId: Yup.string().required("Please select your Fund Type") }
        : ""),
    }),
    onSubmit: (values) => {
      values.workEmail = values.emailAddress;
      JSON.stringify(values, null, 2);
      console.log("here on submit form  ", values);
      onSubmitSignUpHandler(values);
    },
  });

  const handleChange = (e) => {
    console.log("handleChange called");
    if (e === "Hedge_Fund") {
      setIsHedgeFund(true);
    }
  };

  useEffect(() => {
    setSelectedCountry(formik.values.country);
    if (formik.values.country == "United States") {
      setStates(usaStates)
      // setStates(State.getStatesOfCountry("US"));
    }
  }, [formik.values.country]);

  return (
    <div className="initial-screen-content">
      <h1 className="content-title">{title} Sign Up</h1>

      <form onSubmit={formik.handleSubmit}>
        <div className="row gy-md-4 gy-3">
          <div className="col-md-12">
            <div className="form-floating">
              {title === "Fund" ? (
                <InputDropdown
                  id="fundTypeId"
                  placeholder="Fund Type"
                  // forr="investor-type"
                  label="Fund Type"
                  inputDropdownOptions={fundTypeData}
                  // defaultOptionName="Fund type"
                  optionKey={"name"}
                  onChange={handleChange}
                  initialValues="Select Fund Type"
                  // defaultValue="Select Fund Type"
                  {...formik.getFieldProps("fundTypeId")}
                />
              ) : (
                // <InputDropdown
                //   id="fundType"
                //   placeholder="Fund Type"
                //   // forr="investor-type"
                //   label="Fund Type"
                //   inputDropdownOptions={[
                //     { name: "fundTypeData" },
                //     { name: "hedgeFund" },
                //   ]}
                //   defaultOptionName="Fund type"
                //   optionKey={"name"}
                //   onChange={
                //     handleChange // Call the handleChange function if needed
                //   }
                //   defaultValue="Select Fund Type"
                //   {...formik.getFieldProps("fundType")}
                // />
                ""
              )}

              {formik.touched.fundTypeId && formik.errors.fundTypeId ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.fundTypeId}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="text"
                id="name"
                placeholder="First Name"
                label="First Name"
                forr="name"
                {...formik.getFieldProps("name")}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.name}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="text"
                id="surname"
                placeholder="Last Name"
                label="Last Name"
                forr="surname"
                {...formik.getFieldProps("surname")}
              />

              {formik.touched.surname && formik.errors.surname ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.surname}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="companyName"
                id="companyName"
                placeholder="Name of Company"
                label="Name of Company"
                forr="companyName"
                {...formik.getFieldProps("companyName")}
              />

              {companyState.loading && (
                <div className="field-loader">
                  <LoadingDots></LoadingDots>
                </div>
              )}
              {formik.touched.companyName && formik.errors.companyName && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.companyName}
                </div>
              )}
            </div>
          </div>
          {/* <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="email"
                id="workEmail"
                placeholder="Company Email"
                label="Company Email"
                forr="workEmail"
                value={workEmailValue}
                {...formik.getFieldProps("workEmail")}
                onChange={(e) => {
                  formik.setFieldValue("workEmail", e.target.value);
                  setWorkEmailValue(e.target.value);
                }}
              />

              {formik.touched.workEmail && formik.errors.workEmail && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.workEmail}
                </div>
              )}
            </div>
          </div> */}
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="email"
                id="emailAddress"
                placeholder="Email Address"
                label="Email Address"
                forr="emailAddress"
                {...formik.getFieldProps("emailAddress")}
                // disabled={!workEmailValue || formik.errors.workEmail}
              />

              {/* {emailState.loading && (
                <div className="field-loader">
                  <LoadingDots></LoadingDots>
                </div>
              )} */}
              {formik.touched.emailAddress && formik.errors.emailAddress && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.emailAddress}
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="city"
                id="city"
                placeholder="City"
                label="City"
                forr="city"
                {...formik.getFieldProps("city")}
              />
              {formik.touched.zip && formik.errors.zip && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.city}
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="zip"
                id="zip"
                placeholder="Zip"
                label="Zip"
                forr="zip"
                {...formik.getFieldProps("zip")}
              />
              {formik.touched.zip && formik.errors.zip && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.zip}
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <InputDropdown
                id="country"
                placeholder="Select Country"
                // forr="country"
                label="Country"
                inputDropdownOptions={countries}
                // defaultOptionName="Select Country"
                optionKey={"name"}
                onChange={(e) =>
                  console.log("selected country ", e.target.value)
                }
                // defaultValue="Country"
                {...formik.getFieldProps("country")}
              />
              {formik.touched.country && formik.errors.country && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.country}
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              {selectedCountry == "United States" ? (
                <InputDropdown
                  id="state"
                  placeholder="State"
                  // forr="country"
                  label="State"
                  inputDropdownOptions={states}
                  defaultOptionName="State"
                  optionKey={"name"}
                  onChange={(e) =>
                    console.log("selected state ", e.target.value)
                  }
                  defaultValue="State"
                  {...formik.getFieldProps("state")}
                />
              ) : (
                <Input
                  type="state"
                  id="state"
                  placeholder="State"
                  label="State"
                  forr="state"
                  disabled={selectedCountry == ""}
                  {...formik.getFieldProps("state")}
                />
              )}
              {/* <Input
                type="state"
                id="state"
                placeholder="State"
                label="State"
                forr="state"
                {...formik.getFieldProps("state")}
              /> */}
              {formik.touched.state && formik.errors.state && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.state}
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="title"
                id="title"
                placeholder="Title"
                label="Title"
                forr="title"
                {...formik.getFieldProps("title")}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.title}
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <PhoneInputComponent
                label="Office Phone Number"
                placeholder="Office Phone Number"
                value={officePhoneNumber}
                onChange={(phone) => {
                  formik.setFieldValue("officePhoneNumber", `+${phone}`);
                  setOfficePhoneNumber(`+${phone}`);
                }}
              />

              {formik.touched.officePhoneNumber &&
              formik.errors.officePhoneNumber ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.officePhoneNumber}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <PhoneInputComponent
                placeholder="Phone Number"
                label="Cell Number (2FA) *"
                value={phoneNumber}
                onChange={(phone) => {
                  formik.setFieldValue("phoneNumber", `+${phone}`);
                  setPhoneNumber(`+${phone}`);
                }}
              />
              <div className="d-flex justify-content-start">
                <small>
                  <b>{"Cell needed to receive text security code to login"}</b>
                </small>
              </div>

              {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.phoneNumber}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6" style={{ position: "relative" }}>
            {title === "Allocator" ? (
              <InputDropdown
                id="investorTypeId"
                placeholder="Investor type"
                // forr="investor-type"
                label="Investor type"
                inputDropdownOptions={investorTypeData}
                // defaultOptionName="Investor type"
                optionKey={"name"}
                onChange={(e) => console.log(e.target.value)}
                // defaultValue="Investor type"
                initialValues='Select Investor Type'
                {...formik.getFieldProps("investorTypeId")}
              />
            ) : (
              title === "Fund" &&
              formik.values.fundTypeId == window._env_.HEDGE_FUND_TYPE_ID && (
                <InputDropdown
                  id="strategyId"
                  placeholder="Fund Strategy"
                  label="Fund Strategy"
                  initialValues='Select Fund Strategy'
                  inputDropdownOptions={stratagies}
                  // defaultOptionName="Fund Strategy"
                  optionKey={"name"}
                  onChange={(e) => console.log(e.target.value)}
                  // defaultValue="Fund Strategy"
                  {...formik.getFieldProps("strategyId")}
                />
              )
            )}

            {formik.touched.investorTypeId && formik.errors.investorTypeId ? (
              <div className="form-error-message d-flex justify-content-end">
                {formik.errors.investorTypeId}
              </div>
            ) : (
              title === "Fund" &&
              formik.values.fundTypeId == window._env_.HEDGE_FUND_TYPE_ID && (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.strategyId}
                </div>
              )
            )}
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="password"
                id="password"
                placeholder="Enter Password"
                label="Password"
                forr="password"
                {...formik.getFieldProps("password")}
              />

              {formik.touched.password && formik.errors.password ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.password}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating">
              <Input
                type="password"
                id="confirmPassword"
                placeholder="Confirm Password"
                label="Confirm Password"
                forr="confirmPassword"
                {...formik.getFieldProps("confirmPassword")}
              />
              {formik.touched.confirmPassword &&
              formik.errors.confirmPassword ? (
                <div className="form-error-message d-flex justify-content-end">
                  {formik.errors.confirmPassword}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Button
          btnName="Sign Up"
          type="submit"
          btnType="primary"
          loading={loading}
          onClick={formik.handleSubmit}
        />
        <p className="mt-4 mb-0">
          Already have an account?{" "}
          <a href="/login" className="d-inline-block text-blue">
            <u>Login</u>
          </a>
        </p>
      </form>
    </div>
  );
};

RegisterForm.propTypes = {};

export default AuthLayout()(RegisterForm);
